/**
 * Session B1 (UX audit) — client-side funnel analytics.
 *
 * Thin wrapper around GA4's gtag (already loaded via app/index.html). The
 * SPA is hash-routed, so GA4's config snippet only ever sees ONE page_view
 * per full page load — trackPageView() fills that gap from the router, and
 * track() emits the funnel events listed in audit/06-instrumentation-gaps.md.
 *
 * No-ops when gtag is absent (ad-blocker, local dev without network). The
 * server-side funnel_events table is the source of truth for absolute
 * counts; these events exist for GA4's funnel/retention exploration UX.
 */

function gtagSafe(...args) {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag(...args);
        }
    } catch (_) { /* analytics must never break the app */ }
}

/** Emit a GA4 event. Props must be a flat bag of primitives. */
export function track(event, props = {}) {
    gtagSafe('event', event, props);
}

/** SPA route change — GA4 recommended page_view shape for virtual pages. */
export function trackPageView(routeName) {
    gtagSafe('event', 'page_view', {
        page_title: routeName,
        page_location: window.location.origin + '/#' + routeName,
        page_path: '/#' + routeName,
    });
}
